import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import { BASE_URL } from "../../config/axios";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import { useLocation } from "react-router-dom";
import { UpdateProjectAllDetails, AddContractor } from "./ProjectDetailsCrudButtons";
import { BillingDetailsTable, BillTable, ConsultancyDetails, ContractorDetails, COSTable, EmployeeTable, EOTTable, LetterTracking, MilestoneTable, MiscellaneousDocument, Progress } from "./SiteProjectManagementComponents";
import { handleErrorToast } from "../CustomFunctions";
import { CircularGrid, ProjectIcon } from "../AllSvg";
import usePermission from "../../config/permissions";
import { VehicleModelTable } from "./VehicleManagement/VehicleManagementComponenets";
import { SiteInventory } from "./InventoryManagement/InventoryManagementComponent";
import { UploadBulkContractor } from "./BulkModals";
import './ProjectView.css'
import {
  Building2, Calendar, IndianRupee, MapPin, FileText,
  Users, Briefcase, Clock, AlertCircle, CheckCircle,
  Eye, Edit, Lock, ChevronRight, ChevronDown, ChevronUp,
  Download, Share2, MoreVertical, Activity, Target,
  CreditCard, Hash, TrendingUp, UserCheck, Info,
  X, Plus, Save, Loader, Award, Zap, Shield, Bell,
  Mail,
  FileCheck,
  Truck,
  Package
} from 'lucide-react';
// tgr

const SiteProjectBillDetails = () => {

  const location = useLocation();
  const projectData = location.state ? location.state.project : null;
  const projectDataa = location.state ? location.state.project.id : null;

  const [toggleView, setToggleView] = useState("Bill Details");

  // *********** Employee Details Api Start ***********


  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <Dashboardnavbar name={`Bill Details`} url="Site Project" />

      <div className="content-tabs">
        <div className="field-cont-between">
          <div className="attendance-heading font-weight500 font-size-heading">Bill Details of:<br />{projectData.project_short_name}</div>
          <div className="field-cont">
            <div className="table-searchh dropdown-container field-cont-div">
              <select
                onChange={(e) => setToggleView(e.target.value)}
                value={toggleView}
                className="dropdown-wh font-size-subheading  ">
                <option value="Bill Details">Bill Details</option>
                <option value="Bills">Bills</option>
                {/* {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))}; */}

              </select>
            </div>
          </div>

        </div>
        {toggleView === 'Bill Details' ?
          <div >
            <BillingDetailsTable projectId={projectDataa} />
          </div>

          :
          toggleView === 'Bills' ?
            <div >
              <BillTable projectId={projectDataa} />
            </div>
            : null
        }




      </div >
    </>
  );
};


// const ProjectAllDetails = () => {
//   const location = useLocation();
//   const { projectID } = usePermission();

//   const projectIdd = projectID ? projectID : location.state?.project?.id ? location.state?.project?.id : location?.state?.project;
//   const [buffer, setBuffering] = useState(false);
//   console.log(projectIdd, 'location')
//   // State Variables
//   const [projectData, setProjectsData] = useState();
//   const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
//   const [contractorlist, setContractorList] = useState([]);
//   const [contractor, setContractor] = useState(null);
//   const [siteProject, setSiteProject] = useState();

//   const [toggleState, setToggleState] = useState("contractor");
//   const [toggleStatehange, setToggleStatechange] = useState(location?.state?.toggle ? location?.state?.toggle : 10);
//   // const [toggleStatehange, setToggleStatechange] = useState(10);
//   const [consultancyDetailsDetails, setConsultancyDetailsData] = useState([]);
//   const role = sessionStorage.getItem('sitemanagement_role')
//   // Function to Fetch Project Data
//   const getProjects = async () => {
//     setBuffering(true);
//     try {
//       const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
//       setSiteSubCompanyList(sub.data);

//       const proj = await axios.get(`${BASE_URL}/siteproject/project/${projectIdd}/`);
//       setProjectsData(proj.data);

//     } catch (err) {
//       handleErrorToast(err);
//     } finally {
//       setBuffering(false);
//     }
//   };

//   const getConsultancyDetails = async () => {
//     setBuffering(true);
//     try {
//       const response = await axios.get(
//         `${BASE_URL}/siteproject/contractor/${contractor}/`
//       );
//       setConsultancyDetailsData(response.data);
//     } catch (err) {
//     } finally {
//       setBuffering(false);
//     }
//   };

//   console.log("contractor")
//   console.log(contractor)

//   const getProjectContractorDetails = async () => {
//     setBuffering(true);
//     try {
//       const contractordetails = await axios.get(
//         `${BASE_URL}/siteproject/contractorbyproject/${projectIdd}/null/`
//       );
//       setContractorList(contractordetails.data);

//       // Check if the contractor list is not empty and set the last contractor as selected
//       if (contractordetails.data.length > 0) {
//         setContractor(contractordetails.data.slice(-1)[0]?.id); // Using slice to get the last contractor
//       } else {
//         setContractor(undefined); // or handle it accordingly
//       }
//     } catch (err) {
//       // handleErrorToast(err);
//     } finally {
//       setBuffering(false);
//     }
//   };
//   // Load Data on Initial Render
//   useEffect(() => {
//     if (projectIdd != undefined && projectIdd != "") {
//       getProjects();
//       // getProjectContractorDetails();
//       getConsultancyDetails();
//     }

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [contractor, projectIdd]);

//   // Effect to Handle Toggle State Changes
//   useEffect(() => {
//     if (toggleState === "contractor") {
//       getProjectContractorDetails();
//       // Set default toggleStatehange for contractor view
//       setToggleStatechange(11);
//     }
//     if (toggleState === "consultant") {
//       setToggleStatechange(10); // Set to consultant default
//       setContractor(null)
//     }
//     // Add additional logic if needed
//   }, [toggleState]);


//   console.log("PROJECTid")
//   console.log(projectIdd)

//   return (
//     <>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//       <Dashboardnavbar name={`Project Details`} url="Site Project" />

//       <div className="content-tabs">

//         <div className="info-box-div-bg">
//           <div className="jd-heading-outer heading-bg-color-white">
//             <div className="jd-heading-outer-flex">
//               <h2 className="jd-heading-main font-weight600 font-size-heading">
//                 Project Details of "{projectData?.site_prcode} : {projectData?.project_short_name ? projectData?.project_short_name : "-"}"
//               </h2>
//               {
//                 role === "SiteManagement" || role === "Checker" || role === "ViewAccess" ? "" :
//                   <>
//                     {projectData?.lock === false ?
//                       <UpdateProjectAllDetails i={projectData} getProjects={getProjects} siteSubCompanyList={siteSubCompanyList} /> :
//                       <div className="lock-button">
//                         <LockButton />
//                       </div>

//                     }
//                   </>

//               }
//             </div>
//             <div>
//               <div className="jd-heading-bottom-bold"></div>
//               <div className="jd-heading-bottom-light"></div>
//             </div>
//           </div>
//           {/* Project Details */}
//           <tr>
//             <td className="personal-detail-1 font-weight500 font-size-text">Project Name</td>
//             <th className="personal-detail-2 font-weight500 font-size-text">{projectData?.project_name}</th>
//           </tr>
//           <tr>
//             <td className="personal-detail-1 font-weight500 font-size-text">Regional Office Address (RO Address)</td>
//             <th className="personal-detail-2 font-weight500 font-size-text">{projectData?.ro_address ? projectData?.ro_address : "-"}</th>
//           </tr>
//           <tr>
//             <td className="personal-detail-1 font-weight500 font-size-text">Client Address</td>
//             <th className="personal-detail-2 font-weight500 font-size-text">{projectData?.piu_address ? projectData?.piu_address : "-"}</th>
//           </tr>
//           <tr>
//             <td className="personal-detail-1 font-weight500 font-size-text">Project Key Point</td>
//             <th className="personal-detail-2 font-weight500 font-size-text">{projectData?.project_key_point ? projectData?.project_key_point : "-"}</th>
//           </tr>
//         </div>

//         <div className="filter-outer-box">
//           <div className="field-cont">
//             <div title="CC Filter" className="field-cont-div">
//               <CircularGrid />
//               <select
//                 className="attendance-input-field width-10vw date-field"
//                 value={toggleState}
//                 onChange={(e) => setToggleState(e.target.value)}
//                 style={{ cursor: 'pointer' }}
//               >
//                 <option value="contractor">Contractor</option>
//                 <option value="consultant">Consultant</option>
//               </select>
//               {toggleState === "contractor" ? <hr className="field-cont-hr" /> : ""}
//             </div>

//             {/* Contractor Selector */}
//             {Array.isArray(contractorlist) && contractorlist.length > 0 && (
//               <>
//                 {toggleState === "contractor" && (
//                   <div title="Contractor Name" className="field-cont-div">
//                     <ProjectIcon />
//                     {contractorlist.length > 1 ? (
//                       <select
//                         onChange={(e) => setContractor(e.target.value === "" ? undefined : e.target.value)}
//                         value={contractor || ""}
//                         className="attendance-input-field date-field"
//                       >
//                         {contractorlist.map((e) => (
//                           <option key={e.id} value={e.id}>{e.name}</option>
//                         ))}
//                       </select>
//                     ) : (
//                       <div className="attendance-input-field date-field">
//                         {contractorlist[0]?.name}
//                       </div>
//                     )}
//                   </div>
//                 )}

//               </>
//             )}
//           </div>

//           {toggleState === "contractor" ?

//             <>
//               {
//                 (role !== "Checker" || role !== "ViewAccess") &&
//                 <div className="btn-cont">
//                   <AddContractor projectId={projectIdd} getProjects={getProjects} getProjectContractorDetails={getProjectContractorDetails} getDetails={getConsultancyDetails} />
//                   {role === "Admin" && <UploadBulkContractor getdetails={getConsultancyDetails} getContractor={getProjectContractorDetails} site_prcode={projectData?.site_prcode} getProject={getProjects} />}
//                 </div>
//               }
//             </>
//             : ""}
//         </div>

//         {/* Tabs and Content */}

//         {sessionStorage.getItem('sitemanagement_role') === "SiteManagement" ?
//           <div className="toggle-button-area">
//             {toggleState === "consultant" && (
//               <>
//                 <button
//                   className={toggleStatehange === 10 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                   onClick={() => setToggleStatechange(10)}
//                 >
//                   Consultant Details
//                 </button>
//                 <button
//                   className={toggleStatehange === 3 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                   onClick={() => setToggleStatechange(3)}
//                 >
//                   EOT
//                 </button>
//                 <button
//                   className={toggleStatehange === 4 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                   onClick={() => setToggleStatechange(4)}
//                 >
//                   COS
//                 </button>
//               </>

//             )}
//             {Array.isArray(contractorlist) && contractorlist.length > 0 && (
//               <>
//                 {toggleState === "contractor" && (
//                   <>
//                     <button
//                       className={toggleStatehange === 11 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                       onClick={() => setToggleStatechange(11)}
//                     >
//                       Contractor Details
//                     </button>


//                     <button
//                       className={toggleStatehange === 1 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                       onClick={() => setToggleStatechange(1)}
//                     >
//                       Contractor Bills
//                     </button>
//                     <button
//                       className={toggleStatehange === 2 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                       onClick={() => setToggleStatechange(2)}
//                     >
//                       Contractor Billing Details
//                     </button>
//                     <button
//                       className={toggleStatehange === 3 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                       onClick={() => setToggleStatechange(3)}
//                     >
//                       EOT
//                     </button>
//                     <button
//                       className={toggleStatehange === 4 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                       onClick={() => setToggleStatechange(4)}
//                     >
//                       COS
//                     </button>
//                     <button
//                       className={toggleStatehange === 6 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                       onClick={() => setToggleStatechange(6)}
//                     >
//                       Contractor Milestone
//                     </button>


//                     <button
//                       className={toggleStatehange === 9 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                       onClick={() => setToggleStatechange(9)}
//                     >
//                       Site Progress
//                     </button>




//                   </>
//                 )}
//                 <button
//                   className={toggleStatehange === 13 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                   onClick={() => setToggleStatechange(13)}
//                 >
//                   Miscellaneous Documents
//                 </button>

//               </>
//             )}




//           </div>
//           : <div className="toggle-button-area">
//             {toggleState === "consultant" && (
//               <button
//                 className={toggleStatehange === 10 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                 onClick={() => setToggleStatechange(10)}
//               >
//                 Consultant Details
//               </button>
//             )}
//             {Array.isArray(contractorlist) && contractorlist.length > 0 && (
//               <>
//                 {toggleState === "contractor" && (
//                   <>
//                     <button
//                       className={toggleStatehange === 11 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                       onClick={() => setToggleStatechange(11)}
//                     >
//                       Contractor Details
//                     </button>
//                     {sessionStorage.getItem('sitemanagement_role') === "Hr" || sessionStorage.getItem('sitemanagement_role') === "BD" || role === "Checker" ? "" :
//                       <> <button
//                         className={toggleStatehange === 1 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                         onClick={() => setToggleStatechange(1)}
//                       >
//                         Contractor Bills
//                       </button>
//                         <button
//                           className={toggleStatehange === 2 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                           onClick={() => setToggleStatechange(2)}
//                         >
//                           Contractor Billing Details
//                         </button>
//                       </>}
//                     {role !== "Checker" &&
//                       <button
//                         className={toggleStatehange === 6 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                         onClick={() => setToggleStatechange(6)}
//                       >
//                         Contractor Milestone
//                       </button>
//                     }
//                     <button
//                       className={toggleStatehange === 9 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                       onClick={() => setToggleStatechange(9)}
//                     >
//                       Site Progress
//                     </button>
//                     {role !== "Checker" &&
//                       <>
//                         <button
//                           className={toggleStatehange === 3 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                           onClick={() => setToggleStatechange(3)}
//                         >
//                           EOT
//                         </button>
//                         <button
//                           className={toggleStatehange === 4 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                           onClick={() => setToggleStatechange(4)}
//                         >
//                           COS
//                         </button>
//                       </>
//                     }
//                     {sessionStorage.getItem('sitemanagement_role') === "Hr" || sessionStorage.getItem('sitemanagement_role') === "Account" || role === "Checker" ? "" :
//                       <button
//                         className={toggleStatehange === 5 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                         onClick={() => setToggleStatechange(5)}
//                       >
//                         Letters
//                       </button>
//                     }
//                   </>
//                 )}
//               </>
//             )}

//             {toggleState === "consultant" && (
//               <>
//                 {role !== "Checker" &&
//                   <>
//                     <button
//                       className={toggleStatehange === 3 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                       onClick={() => setToggleStatechange(3)}
//                     >
//                       EOT
//                     </button>
//                     <button
//                       className={toggleStatehange === 4 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                       onClick={() => setToggleStatechange(4)}
//                     >
//                       COS
//                     </button>
//                     {sessionStorage.getItem('sitemanagement_role') === "Hr" || sessionStorage.getItem('sitemanagement_role') === "Account" || role === "Checker" ? "" :
//                       <button
//                         className={toggleStatehange === 5 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                         onClick={() => setToggleStatechange(5)}
//                       >
//                         Letters
//                       </button>
//                     }
//                   </>}

//                 <button
//                   className={toggleStatehange === 7 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                   onClick={() => setToggleStatechange(7)}
//                 >
//                   Employee
//                 </button>
//                 <button
//                   className={toggleStatehange === 8 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                   onClick={() => setToggleStatechange(8)}
//                 >
//                   Vehicles
//                 </button>
//                 <button
//                   className={toggleStatehange === 12 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//                   onClick={() => setToggleStatechange(12)}
//                 >
//                   Inventory
//                 </button>

//               </>
//             )}
//             <button
//               className={toggleStatehange === 13 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
//               onClick={() => setToggleStatechange(13)}
//             >
//               Miscellaneous Documents
//             </button>




//           </div>}




//         {/* Dynamic Component Loading */}
//         {sessionStorage.getItem('sitemanagement_role') === "SiteManagement" ?
//           <>
//             <div className="info-box-div-without-bg">
//               {toggleStatehange === 1 && toggleState === "contractor" && <BillTable projectId={projectIdd} contractor={contractor} contractorlist={contractorlist} site_prcode={projectData?.site_prcode ? projectData.site_prcode : location.state.project_code} contractor_name={consultancyDetailsDetails.name} />}
//               {toggleStatehange === 2 && toggleState === "contractor" && <BillingDetailsTable projectId={projectIdd} contractor={contractor} contractor_name={consultancyDetailsDetails.name} costwithCOS={consultancyDetailsDetails.cost_with_cos} contractorAmount={consultancyDetailsDetails.cost} />}
//               {toggleStatehange === 10 && <ConsultancyDetails projectId={projectIdd} projectData={projectData} getProjects={getProjects} buffer={buffer} siteSubCompanyList={siteSubCompanyList} />}
//               {Array.isArray(contractorlist) && contractorlist.length > 0 && (
//                 <>
//                   {toggleStatehange === 11 && toggleState === "contractor" && <ContractorDetails contractor={contractor} />}
//                 </>
//               )}
//               {toggleStatehange === 3 && <EOTTable contractor_id={consultancyDetailsDetails.id} projectId={projectIdd} toggleState={toggleState} contractor={contractor} contractorlist={contractorlist} site_prcode={projectData ? projectData?.site_prcode : location.state.project_code} contractor_name={consultancyDetailsDetails.name} contractor_date={consultancyDetailsDetails.schedule_construction_completion_date} contractor_updated_date={consultancyDetailsDetails.schedule_construction_completion_date_with_eot} EOTDays={consultancyDetailsDetails.EOT_Days} />}
//               {toggleStatehange === 4 && <COSTable projectId={projectIdd} toggleState={toggleState} contractor={contractor} contractorlist={contractorlist} site_prcode={projectData?.site_prcode ? projectData.site_prcode : location.state.project_code} contractor_name={consultancyDetailsDetails.name} />}
//               {toggleStatehange === 6 && toggleState === "contractor" && <MilestoneTable projectId={projectIdd} appointed_date={projectData?.loa_award_date} contractor={contractor} contractorlist={getConsultancyDetails} />}
//               {toggleStatehange === 9 && <Progress projectId={projectIdd} contractor={contractor} contractorlist={contractorlist} />}
//               {toggleStatehange === 13 && <MiscellaneousDocument p_id={projectIdd} site_prcode={projectData.site_prcode ? projectData.site_prcode : location.state.project_code} toggleState={toggleState} />}



//             </div>

//           </>
//           :
//           <div className="info-box-div-without-bg">
//             {toggleStatehange === 1 && toggleState === "contractor" && <BillTable projectName={projectData?.project_short_name} projectId={projectIdd} contractor={contractor} contractorlist={contractorlist} contractor_name={consultancyDetailsDetails.name} site_prcode={projectData.site_prcode ? projectData.site_prcode : location.state.project_code} />}
//             {toggleStatehange === 2 && toggleState === "contractor" && <BillingDetailsTable projectName={projectData?.project_short_name} projectId={projectIdd} contractor={contractor} contractor_name={consultancyDetailsDetails.name} costwithCOS={consultancyDetailsDetails.cost_with_cos} contractorAmount={consultancyDetailsDetails.cost} />}
//             {toggleStatehange === 3 && <EOTTable contractor_id={consultancyDetailsDetails.id} projectName={projectData?.project_short_name} projectId={projectIdd} toggleState={toggleState} contractor={contractor} contractorlist={contractorlist} site_prcode={projectData ? projectData.site_prcode : location.state.project_code} contractor_name={consultancyDetailsDetails.name} contractor_date={consultancyDetailsDetails.schedule_construction_completion_date} contractor_updated_date={consultancyDetailsDetails.schedule_construction_completion_date_with_eot} EOTDays={consultancyDetailsDetails.EOT_Days} />}
//             {toggleStatehange === 4 && <COSTable projectName={projectData?.project_short_name} projectId={projectIdd} toggleState={toggleState} contractor={contractor} contractorlist={contractorlist} site_prcode={projectData.site_prcode ? projectData.site_prcode : location.state.project_code} contractor_name={consultancyDetailsDetails.name} />}
//             {
//               sessionStorage.getItem('sitemanagement_role') === "Hr" ? "" :
//                 <>
//                   {toggleStatehange === 5 && <LetterTracking projectId={projectIdd} projectName={projectData?.project_short_name} site_prcode={projectData?.site_prcode ? projectData.site_prcode : location.state.project_code} letterBy={toggleState} contractor={contractor} contractor_name={consultancyDetailsDetails.name} contractorlist={contractorlist} />}
//                 </>
//             }
//             {toggleStatehange === 6 && toggleState === "contractor" && <MilestoneTable projectName={projectData?.project_short_name} projectId={projectIdd} toggleState={toggleState} contractor={contractor} contractorlist={contractorlist} site_prcode={projectData.site_prcode ? projectData.site_prcode : location.state.project_code} contractor_name={consultancyDetailsDetails.name} />}
//             {toggleStatehange === 7 && toggleState === "consultant" && <EmployeeTable projectName={projectData?.project_short_name} projectId={projectIdd} companyId={projectData?.sub_company} site_prcode={projectData.site_prcode ? projectData.site_prcode : location.state.project_code} />}
//             {toggleStatehange === 8 && toggleState === "consultant" && <VehicleModelTable p_id={projectIdd} site_prcode={projectData.site_prcode ? projectData.site_prcode : location.state.project_code} usedin="ProjectDetails" />}
//             {toggleStatehange === 12 && toggleState === "consultant" && <SiteInventory p_id={projectIdd} site_prcode={projectData.site_prcode ? projectData.site_prcode : location.state.project_code} ischild={true} />}
//             {toggleStatehange === 13 && <MiscellaneousDocument p_id={projectIdd} site_prcode={projectData.site_prcode ? projectData.site_prcode : location.state.project_code} toggleState={toggleState} />}

//             {toggleStatehange === 9 && <Progress projectName={projectData?.project_short_name} projectId={projectIdd} contractor={contractor} contractorlist={contractorlist} site_prcode={projectData.site_prcode ? projectData.site_prcode : location.state.project_code} contractor_name={consultancyDetailsDetails.name} />}
//             {toggleStatehange === 10 && <ConsultancyDetails projectId={projectIdd} projectData={projectData} getProjects={getProjects} buffer={buffer} siteSubCompanyList={siteSubCompanyList} site_prcode={projectData?.site_prcode} />}
//             {Array.isArray(contractorlist) && contractorlist.length > 0 && (
//               <>
//                 {toggleStatehange === 11 && toggleState === "contractor" && <ContractorDetails projectId={projectIdd} contractor={contractor} getContractorDetails={getProjectContractorDetails} getProjects={getProjects} getcontractor={getConsultancyDetails} />}
//               </>
//             )}
//           </div>
//         }

//       </div >
//     </>
//   );
// };


const ProjectAllDetails = () => {
  const location = useLocation();
  const { projectID } = usePermission();
  const projectIdd = projectID ? projectID : location.state?.project?.id ? location.state?.project?.id : location?.state?.project;

  const [buffer, setBuffering] = useState(false);
  const [projectData, setProjectsData] = useState();
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
  const [contractorlist, setContractorList] = useState([]);
  const [contractor, setContractor] = useState(null);
  const [toggleState, setToggleState] = useState("contractor");
  const [toggleStatehange, setToggleStatechange] = useState(location?.state?.toggle ? location?.state?.toggle : 10);
  const [consultancyDetailsDetails, setConsultancyDetailsData] = useState([]);

  const role = sessionStorage.getItem('sitemanagement_role');
  const isSiteManagement = role === "SiteManagement";
  const isHr = role === "Hr";
  const isChecker = role === "Checker";
  const isViewAccess = role === "ViewAccess";

  // Fetch Project Data
  const getProjects = async () => {
    setBuffering(true);
    try {
      const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSiteSubCompanyList(sub.data);
      const proj = await axios.get(`${BASE_URL}/siteproject/project/${projectIdd}/`);
      setProjectsData(proj.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  const getConsultancyDetails = async () => {
    if (!contractor) return;
    setBuffering(true);
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/contractor/${contractor}/`);
      setConsultancyDetailsData(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setBuffering(false);
    }
  };

  const getProjectContractorDetails = async () => {
    setBuffering(true);
    try {
      const contractordetails = await axios.get(`${BASE_URL}/siteproject/contractorbyproject/${projectIdd}/null/`);
      setContractorList(contractordetails.data);
      if (contractordetails.data.length > 0) {
        setContractor(contractordetails.data.slice(-1)[0]?.id);
      } else {
        setContractor(undefined);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    if (projectIdd !== undefined && projectIdd !== "") {
      getProjects();
    }
  }, [projectIdd]);

  useEffect(() => {
    if (contractor) {
      getConsultancyDetails();
    }
  }, [contractor]);

  useEffect(() => {
    if (toggleState === "contractor") {
      getProjectContractorDetails();
      setToggleStatechange(11);
    }
    if (toggleState === "consultant") {
      setToggleStatechange(10);
      setContractor(null);
    }
  }, [toggleState]);

  // Get project status badge
  const getStatusBadge = () => {
    if (projectData?.actual_completion_date) return { type: 'success', text: 'Completed', icon: CheckCircle };
    if (projectData?.schedule_completion_date) return { type: 'warning', text: 'In Progress', icon: Activity };
    if (projectData?.commencement_date) return { type: 'info', text: 'Yet to Commence', icon: Clock };
    return { type: 'secondary', text: 'Planning', icon: Info };
  };

  const status = projectData ? getStatusBadge() : { type: 'secondary', text: 'Loading', icon: Info };
  const StatusIcon = status.icon;

  // Tab configurations with all components
  const getVisibleTabs = () => {
    if (isSiteManagement) {
      if (toggleState === "contractor") {
        return [
          { id: 11, label: 'Contractor Details', icon: Building2, show: true },
          { id: 1, label: 'Contractor Bills', icon: IndianRupee, show: true },
          { id: 2, label: 'Billing Details', icon: FileText, show: true },
          { id: 6, label: 'Milestone', icon: Target, show: true },
          { id: 9, label: 'Site Progress', icon: Activity, show: true },
          { id: 3, label: 'EOT', icon: Clock, show: true },
          { id: 4, label: 'COS', icon: Award, show: true },
          { id: 13, label: 'Miscellaneous', icon: FileCheck, show: true },
        ];
      } else {
        return [
          { id: 10, label: 'Consultant Details', icon: Building2, show: true },
          { id: 3, label: 'EOT', icon: Clock, show: true },
          { id: 4, label: 'COS', icon: Award, show: true },
          { id: 13, label: 'Miscellaneous', icon: FileCheck, show: true },
        ];
      }
    }

    // Non-SiteManagement roles
    let tabs = [];
    if (toggleState === "contractor") {
      tabs = [
        { id: 11, label: 'Contractor Details', icon: Building2, show: true },
        { id: 9, label: 'Site Progress', icon: Activity, show: true },
      ];

      if (!isChecker && !isHr && !isViewAccess) {
        tabs.push(
          { id: 1, label: 'Contractor Bills', icon: IndianRupee, show: true },
          { id: 2, label: 'Billing Details', icon: FileText, show: true },
          { id: 6, label: 'Milestone', icon: Target, show: true },
          { id: 3, label: 'EOT', icon: Clock, show: true },
          { id: 4, label: 'COS', icon: Award, show: true }
        );
      }

      if (!isChecker && !isHr && !isViewAccess) {
        tabs.push({ id: 5, label: 'Letters', icon: Mail, show: true });
      }

      tabs.push({ id: 13, label: 'Miscellaneous', icon: FileCheck, show: true });
    } else {
      tabs = [
        { id: 10, label: 'Consultant Details', icon: Building2, show: true },
      ];

      if (!isChecker && !isHr && !isViewAccess) {
        tabs.push(
          { id: 3, label: 'EOT', icon: Clock, show: true },
          { id: 4, label: 'COS', icon: Award, show: true }
        );
      }

      if (!isChecker && !isHr && !isViewAccess) {
        tabs.push({ id: 5, label: 'Letters', icon: Mail, show: true });
      }

      tabs.push(
        { id: 7, label: 'Employee', icon: Users, show: true },
        { id: 8, label: 'Vehicles', icon: Truck, show: true },
        { id: 12, label: 'Inventory', icon: Package, show: true },
        { id: 13, label: 'Miscellaneous', icon: FileCheck, show: true }
      );
    }

    return tabs;
  };

  const visibleTabs = getVisibleTabs();

  // Render the active component based on toggleStatehange
  const renderActiveComponent = () => {
    const commonProps = {
      projectId: projectIdd,
      projectData: projectData,
      contractor: contractor,
      contractorlist: contractorlist,
      consultancyDetailsDetails: consultancyDetailsDetails,
      siteSubCompanyList: siteSubCompanyList,
      getProjects: getProjects,
      getContractorDetails: getProjectContractorDetails,
      getcontractor: getConsultancyDetails,
      site_prcode: projectData?.site_prcode,
      contractor_name: consultancyDetailsDetails?.name,
      grace_period: consultancyDetailsDetails?.grace_period,
      contractor_date: consultancyDetailsDetails?.schedule_construction_completion_date,
      contractor_updated_date: consultancyDetailsDetails?.schedule_construction_completion_date_with_eot,
      EOTDays: consultancyDetailsDetails?.EOT_Days,
      costwithCOS: consultancyDetailsDetails?.cost_with_cos,
      contractorAmount: consultancyDetailsDetails?.cost,
      companyId: projectData?.sub_company,
      p_id: projectIdd,
      usedin: "ProjectDetails",
      ischild: true,
      letterBy: toggleState,
      toggleState: toggleState,
      projectName: projectData?.project_short_name,
      appointed_date: projectData?.loa_award_date,
      buffer: buffer,
    };

    switch (toggleStatehange) {
      // Contractor Bills
      case 1:
        return <BillTable {...commonProps} />;

      // Contractor Billing Details
      case 2:
        return <BillingDetailsTable {...commonProps} />;

      // EOT Table
      case 3:
        return <EOTTable
          contractor_id={consultancyDetailsDetails?.id}
          {...commonProps}
        />;

      // COS Table
      case 4:
        return <COSTable {...commonProps} />;

      // Letter Tracking
      case 5:
        return <LetterTracking {...commonProps} />;

      // Milestone Table
      case 6:
        return <MilestoneTable {...commonProps} />;

      // Employee Table
      case 7:
        return <EmployeeTable {...commonProps} />;

      // Vehicle Model Table
      case 8:
        return <VehicleModelTable {...commonProps} />;

      // Progress/Site Progress
      case 9:
        return <Progress {...commonProps} />;

      // Consultancy Details
      case 10:
        return <ConsultancyDetails {...commonProps} />;

      // Contractor Details
      case 11:
        return <ContractorDetails {...commonProps} />;

      // Site Inventory
      case 12:
        return <SiteInventory {...commonProps} />;

      // Miscellaneous Documents
      case 13:
        return <MiscellaneousDocument
          p_id={projectIdd}
          site_prcode={projectData?.site_prcode}
          toggleState={toggleState}
        />;

      default:
        return null;
    }
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <Dashboardnavbar name="Project Details" url="Site Project" />

      <div className="project-details-modern">
        {/* Project Header Card */}
        <div className="project-header-modern">
          <div className="project-header-content">
            <div className="project-title-section">
              <div className="project-badge-large">
                <span className="project-code-badge">{projectData?.site_prcode || '-'}</span>
                <span className={`status-badge ${status.type}`}>
                  <StatusIcon size={12} />
                  {status.text}
                </span>
              </div>
              <h1 className="project-name-large">
                {projectData?.project_short_name || '-'}
              </h1>
              <p className="project-full-name">{projectData?.project_name || '-'}</p>
            </div>

            <div className="project-actions">
              {!isSiteManagement && !isChecker && !isViewAccess && (
                projectData?.lock === false ? (
                  <UpdateProjectAllDetails
                    i={projectData}
                    getProjects={getProjects}
                    siteSubCompanyList={siteSubCompanyList}
                  />
                ) : (
                  <div className="lock-button-modern">
                    <Lock size={16} />
                    <span>Locked</span>
                  </div>
                )
              )}
            </div>
          </div>

          {/* Quick Stats Grid */}
          <div className="quick-stats-grid">
            <div className="stat-card-mini">
              <MapPin size={16} />
              <div>
                <span className="stat-labels" style={{ marginTop: "2px" }}>Location</span>
                <span className="stat-values">{projectData?.location || '-'}</span>
              </div>
            </div>
            <div className="stat-card-mini">
              <Building2 size={16} />
              <div>
                <span className="stat-labels" style={{ marginTop: "2px" }}>Client</span>
                <span className="stat-values">{projectData?.client_name || '-'}</span>
              </div>
            </div>
            <div className="stat-card-mini">
              <TrendingUp size={16} />
              <div>
                <span className="stat-labels" style={{ marginTop: "2px" }}>Escalation Applicable On</span>
                <span className="stat-values">{projectData?.escalation_apllicable_on || '-'}</span>
              </div>
            </div>
            <div className="stat-card-mini">
              <TrendingUp size={16} />
              <div>
                <span className="stat-labels" style={{ marginTop: "2px" }}>Project Length</span>
                <span className="stat-values">{projectData?.project_length || '-'} KM</span>
              </div>
            </div>
            <div className="stat-card-mini">
              <Briefcase size={16} />
              <div>
                <span className="stat-labels" style={{ marginTop: "2px" }}>Work Type</span>
                <span className="stat-values">{projectData?.work_type?.split(' - ')[0] || '-'}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="project-content-modern">
          {/* Filter Bar */}
          <div className="filter-bar-modern">
            <div className="filter-group">
              <div className="filter-select">
                <CircularGrid />
                <select
                  className="modern-select"
                  value={toggleState}
                  onChange={(e) => setToggleState(e.target.value)}
                >
                  <option value="contractor">Contractor View</option>
                  <option value="consultant">Consultant View</option>
                </select>
              </div>

              {toggleState === "contractor" && contractorlist.length > 0 && (
                <div className="filter-select">
                  <ProjectIcon />
                  {contractorlist.length > 1 ? (
                    <select
                      onChange={(e) => setContractor(e.target.value === "" ? undefined : e.target.value)}
                      value={contractor || ""}
                      className="modern-select"
                    >
                      {contractorlist.map((e) => (
                        <option key={e.id} value={e.id}>{e.name}</option>
                      ))}
                    </select>
                  ) : (
                    <div className="selected-contractor">{contractorlist[0]?.name}</div>
                  )}
                </div>
              )}
            </div>

            {toggleState === "contractor" && !isChecker && !isViewAccess && (
              <div className="action-buttons-group">
                <AddContractor
                  projectId={projectIdd}
                  getProjects={getProjects}
                  getProjectContractorDetails={getProjectContractorDetails}
                  getDetails={getConsultancyDetails}
                  usefor="projectDetails"
                />
                {role === "Admin" && (
                  <UploadBulkContractor
                    getdetails={getConsultancyDetails}
                    getContractor={getProjectContractorDetails}
                    site_prcode={projectData?.site_prcode}
                    getProject={getProjects}
                  />
                )}
              </div>
            )}
          </div>

          {/* Modern Tabs */}
          {consultancyDetailsDetails?.length === 0 && toggleState === "contractor" ? (
            <>
            </>) :

            <div className="modern-tabs-container">
              <div className="tabs-scroll">
                {visibleTabs.map((tab) => {
                  const Icon = tab.icon;
                  return (
                    <button
                      key={tab.id}
                      className={`modern-tab-btn ${toggleStatehange === tab.id ? 'active' : ''}`}
                      onClick={() => setToggleStatechange(tab.id)}
                    >
                      <Icon size={16} />
                      <span>{tab.label}</span>
                      {toggleStatehange === tab.id && <div className="active-indicator" />}
                    </button>
                  );
                })}
              </div>
            </div>
          }

          {/* Tab Content */}
          <div className="tab-content-modern">
            {buffer ? (
              <div className="loader-container-modern">
                <Loader size={48} className="spinning" />
                <p>Loading data...</p>
              </div>
            ) : (
              renderActiveComponent()
            )}
          </div>
        </div>
      </div>
    </>
  );
};




export {
  SiteProjectBillDetails,
  ProjectAllDetails,


};
